import React from 'react'
import styles from './styles.module.scss'

export function TermsOfUseRender() {
  return (
    <div className={styles.termsTemplate}>
      <p className={styles.lastUpdate}>
        Última atualização: 12 de setembro de 2025
      </p>

      <div className={styles.space}>
        <h2>PREÂMBULO – PORTAIS WHITE LABEL</h2>
        <p>
          Este portal é operado pela{' '}
          <strong>RESALE TECNOLOGIA S.A. (“RESALE”)</strong>, por meio da sua
          Plataforma tecnológica, em modelo white label.
        </p>
        <p>
          Os imóveis disponibilizados neste ambiente são ofertados
          exclusivamente pela{' '}
          <strong>EMPRESA GESTORA DE ATIVOS S.A. – EMGEA</strong>, disponível em
          (<strong>https://emgeaimoveis.com.br/</strong>) que figura como
          responsável pela venda em cada operação.
        </p>
        <p>
          A RESALE, por sua vez, atua como operadora da Plataforma e prestadora
          de serviços tecnológicos e operacionais, observadas as condições
          previstas neste Termo, nos regulamentos e nos instrumentos aplicáveis
          a cada modalidade de venda.
        </p>
        <p>
          Assim, este Termo de Uso da Plataforma RESALE aplica-se integralmente
          a este Portal, com as adaptações decorrentes da característica de
          exclusividade do vendedor identificado acima.
        </p>
      </div>

      <div className={styles.space}>
        <h2 className={styles.spaceTop}>COMO LER ESTE TERMO</h2>
        <p>
          Escrevemos este Termo de forma objetiva e direta. Aqui você encontra:
          (i) como usar a Plataforma; (ii) como funcionam os produtos e tipos de
          venda; (iii) responsabilidades de cada parte; e (iv) informações sobre
          taxas, dados pessoais e comunicações. Recomendamos a leitura integral
          antes de usar a Plataforma.
        </p>

        <div className={styles.space}>
          <h2 className={styles.spaceTop}>1) CLÁUSULA DE ABERTURA</h2>

          <ol type="a">
            <li>
              <p>Apresentação da RESALE</p>
              <ol type="i">
                <li>
                  A RESALE TECNOLOGIA E SERVIÇOS S.A., sociedade anônima,
                  inscrita no CNP/J/ME sob o nº 21.129.873/0001-79, com sede na
                  Av. Independência, nº 950, sala 142, bairro Alemães, cidade de
                  Piracicaba/SP, CEP 13419-155, doravante denominada
                  simplesmente “RESALE”, é a operadora da plataforma digital de
                  intermediação de compra e venda de imóveis, disponível no site{' '}
                  <a
                    href="https://www.resale.com.br"
                    target="_blank"
                    rel="noreferrer"
                  >
                    www.resale.com.br
                  </a>{' '}
                  e demais domínios e interfaces vinculadas (“Plataforma”).
                </li>
              </ol>
            </li>

            <li>
              <p>Objeto do Termo</p>
              <ol type="i">
                <li>
                  Este Termo estabelece as condições gerais de uso da
                  Plataforma, bem como os direitos e deveres dos Usuários
                  (compradores, vendedores e anunciantes), em relação aos
                  produtos, modalidades de venda e serviços disponibilizados
                  pela RESALE, nos termos da legislação aplicável.
                </li>
              </ol>
            </li>

            <li>
              <p>Consentimento e vinculação</p>
              <ol type="i">
                <li>
                  Ao acessar, se cadastrar, navegar ou utilizar qualquer
                  funcionalidade da Plataforma, o Usuário declara ter lido,
                  compreendido e aceito integralmente este Termo, obrigando-se a
                  cumpri-lo de forma integral, bem como a Política de
                  Privacidade e os regulamentos específicos aplicáveis à
                  modalidade de venda utilizada.
                </li>
              </ol>
            </li>
          </ol>
        </div>

        <div className={styles.space}>
          <h2 className={styles.spaceTop}>2) DEFINIÇÕES</h2>

          <ol type="a">
            <li>
              <p>Para fins deste Termo, aplicam-se as seguintes definições:</p>
              <ol type="i">
                <li>
                  <span className={styles.underline}>Plataforma RESALE</span>:
                  ambiente eletrônico gerenciado pela RESALE para intermediação
                  de compra e venda de imóveis, incluindo as interfaces web,
                  aplicativos e canais integrados de venda.
                </li>

                <li>
                  <span className={styles.underline}>Usuário</span>: qualquer
                  pessoa física ou jurídica que utilize a Plataforma, seja como
                  vendedor, comprador, anunciante ou mero visitante.
                </li>

                <li>
                  <span className={styles.underline}>Produto</span>: categoria
                  comercial de oferta na Plataforma. Os produtos atualmente
                  disponíveis são:
                  <div>
                    <p>(1) B2B (venda institucional);</p>
                    <p>(2) Resale Fast;</p>
                    <p>(3) Proposta Rápida.</p>
                  </div>
                </li>

                <li>
                  <span className={styles.underline}>Tipos de Venda</span>:
                  forma de estruturação da negociação dentro da Plataforma. As
                  modalidades atualmente vigentes são:
                  <div>
                    <p>(1) Leilão;</p>
                    <p>
                      (2) Venda Direta, que pode ocorrer nas seguintes
                      modalidades, de forma digital ou por meio de corretores
                      e/ou imobiliárias: Fila Única e Melhor Proposta.
                    </p>
                  </div>
                </li>

                <li>
                  <span className={styles.underline}>
                    Comprador Qualificado
                  </span>
                  : pessoa física ou jurídica que atenda aos critérios definidos
                  pela RESALE quanto à experiência, capacidade financeira ou
                  documental para aquisição de imóveis por meio da Plataforma.
                </li>

                <li>
                  <span className={styles.underline}>Pagimovel®</span>: unidade
                  de negócios da RESALE responsável pela condução do processo de
                  escrituração e registro dos imóveis, quando contratada.
                </li>

                <li>
                  <span className={styles.underline}>
                    Edital ou Regulamento Específico
                  </span>
                  : nstrumento que disciplina condições particulares de
                  determinado tipo de venda, produto ou imóvel ofertado, o qual
                  prevalecerá sobre este Termo em caso de conflito, quando
                  expressamente previsto.
                </li>
              </ol>
            </li>
          </ol>
        </div>

        <div className={styles.space}>
          <h2 className={styles.spaceTop}>
            3) ESTRUTURA COMERCIAL DA PLATAFORMA
          </h2>

          <ol type="a">
            <li>
              <p>Produtos Disponíveis</p>
              <ol type="i">
                <li>
                  A Plataforma opera com os seguintes modelos de venda:
                  <div>
                    <p>
                      (1) <strong>B2B (Venda Institucional):</strong> Imóveis
                      ofertados por grandes instituições vendedoras, com nome
                      identificado na Plataforma. As condições de venda podem
                      seguir regramento próprio da instituição, incluindo regras
                      de diligência, prazos, responsabilidades e documentação.
                    </p>
                    <p>
                      (2) <strong>Resale Fast:</strong> Produto voltado para
                      compradores qualificados, com foco em agilidade e
                      liquidez. A negociação ocorre por meio da submissão de
                      propostas diretamente aos vendedores, condicionadas à
                      aprovação destes. O pós-venda pode ser conduzido pelo
                      próprio vendedor ou por parceiro por ele indicado.
                    </p>
                    <p>
                      (3) <strong>Proposta Rápida:</strong> Produto voltado para
                      compradores com condições de efetivar a compra de forma
                      ágil e com foco em velocidade. A negociação ocorre
                      mediante envio de propostas diretamente aos vendedores,
                      condicionadas à aprovação destes. O processo de pós-venda
                      é conduzido pela Pagimovel®.
                    </p>
                  </div>
                </li>
              </ol>
            </li>

            <li>
              <p>Tipos de Venda</p>
              <ol type="i">
                <li>A Plataforma opera com os seguintes modelos de venda:</li>
                <div>
                  <p>
                    (1) <span className={styles.underline}>Leilão:</span>{' '}
                    modalidade de venda regida por edital próprio, publicado
                    junto ao imóvel. Em caso de conflito entre este Termo e o
                    edital, prevalecerá o disposto no respectivo edital.
                  </p>
                  <p>
                    (2) <span className={styles.underline}>Venda Direta:</span>{' '}
                    Modalidade em que o imóvel é ofertado ao público de forma
                    aberta, com propostas submetidas pela Plataforma. Pode
                    ocorrer sob duas submodalidades:
                    <div>
                      <p className={styles.paddingLeft}>
                        (a) Fila Única: as propostas são analisadas por ordem
                        cronológica de envio.
                      </p>
                      <p className={styles.paddingLeft}>
                        (b) Melhor Proposta: metodologia de venda com envio de
                        propostas fechadas por prazo determinado, sujeita à
                        aprovação do vendedor e às regras do Regulamento
                        específico disponível na Plataforma.
                      </p>
                    </div>
                  </p>
                </div>
              </ol>
            </li>

            <li>
              <p>Composição Contratual</p>
              <ol type="i">
                <li>
                  As relações decorrentes da utilização da Plataforma podem ser
                  reguladas por outros instrumentos jurídicos, como: Editais de
                  Leilão; Regulamentos específicos de produtos; Instrumentos de
                  prestação de serviços; Promessa de Compra e Venda, Contrato
                  Particular, Escritura Pública ou outro instrumento de
                  alienação aplicável. Estes documentos complementarão ou
                  prevalecerão sobre o presente Termo, conforme aplicável ao
                  caso concreto.
                </li>
              </ol>
            </li>
          </ol>
        </div>

        <div className={styles.space}>
          <h2 className={styles.spaceTop}>4) CADASTRO E ACESSO À PLATAFORMA</h2>

          <ol type="a">
            <li>
              <p>Requisitos para Cadastro</p>
              <ol type="i">
                <li>
                  Para utilizar a Plataforma, o Usuário deverá possuir
                  capacidade civil plena e fornecer, no momento do cadastro,
                  todas as informações solicitadas de forma completa, precisa e
                  verdadeira, incluindo dados pessoais, documentos e contatos
                  atualizados.
                </li>
              </ol>
            </li>

            <li>
              <p>Veracidade das Informações</p>
              <ol type="i">
                <li>
                  O Usuário é exclusivamente responsável pela veracidade,
                  integridade e atualização dos dados fornecidos. A RESALE
                  poderá suspender ou excluir o acesso de Usuários que
                  apresentem informações falsas, incompletas, inválidas ou que
                  levantem suspeitas de fraude ou má-fé.
                </li>
              </ol>
            </li>

            <li>
              <p>Cadastro de Pessoas Jurídicas</p>
              <ol type="i">
                <li>
                  No caso de Usuários pessoa jurídica, o cadastro deverá ser
                  realizado por representante legal com poderes suficientes,
                  sendo exigida, quando aplicável, documentação comprobatória.
                </li>
              </ol>
            </li>

            <li>
              <p>Confidencialidade e Segurança da Conta</p>
              <ol type="i">
                <li>
                  O Usuário se compromete a manter sigilo sobre seus dados de
                  acesso à Plataforma (login e senha), responsabilizando-se
                  integralmente por qualquer atividade realizada com seu
                  usuário, ainda que por terceiros.
                </li>
              </ol>
            </li>

            <li>
              <p>Aprovação do Cadastro</p>
              <ol type="i">
                <li>
                  O cadastro na Plataforma está sujeito à análise e aprovação
                  pela RESALE, que poderá, a seu critério, solicitar documentos
                  adicionais, realizar validações ou recusar o cadastro sem
                  obrigação de justificar a decisão.
                </li>
              </ol>
            </li>

            <li>
              <p>Suspensão e Encerramento</p>
              <ol type="i">
                <li>
                  A RESALE poderá limitar, suspender ou encerrar o acesso do
                  Usuário à Plataforma, sem direito a indenização, nas seguintes
                  hipóteses:
                  <div>
                    <p>
                      (1) descumprimento deste Termo ou de regulamentos
                      aplicáveis;
                    </p>
                    <p>
                      (2) suspeita de fraude, uso indevido ou prática de atos
                      ilícitos;
                    </p>
                    <p>(3) decisão de autoridade competente;</p>
                    <p>
                      (4) motivos técnicos ou operacionais que impeçam a
                      continuidade do serviço.
                    </p>
                  </div>
                </li>
              </ol>
            </li>
          </ol>
        </div>

        <div className={styles.space}>
          <h2 className={styles.spaceTop}>
            5) CONDIÇÕES GERAIS DE USO DA PLATAFORMA
          </h2>

          <ol type="a">
            <li>
              <p>Utilização da Plataforma</p>
              <ol type="i">
                <li>
                  Ao utilizar a Plataforma, o Usuário se compromete a fazê-lo de
                  forma ética, lícita e conforme as finalidades aqui descritas,
                  abstendo-se de qualquer prática que possa prejudicar
                  terceiros, a RESALE ou o regular funcionamento da Plataforma.
                </li>
              </ol>
            </li>

            <li>
              <p>Proibições</p>
              <ol type="i">
                <li>
                  É vedado ao Usuário, sem prejuízo de outras restrições legais
                  ou contratuais: tentar burlar sistemas de segurança ou
                  autenticação; disseminar vírus, bots, malware ou qualquer
                  outro código malicioso; realizar ou tentar realizar engenharia
                  reversa, scraping ou mineração de dados; cadastrar imóveis ou
                  enviar propostas com dados inverídicos, incompletos ou com
                  intenção de simular interesse fictício; usar identidades
                  falsas ou de terceiros sem autorização; praticar qualquer
                  forma de manipulação de resultado, concorrência desleal ou
                  fraude.
                </li>
              </ol>
            </li>

            <li>
              <p>Integridade e Segurança da Plataforma</p>
              <ol type="i">
                <li>
                  A RESALE adota práticas de segurança da informação compatíveis
                  com os padrões de mercado. No entanto, o Usuário declara estar
                  ciente de que nenhum sistema é totalmente isento de falhas,
                  assumindo os riscos relacionados ao uso da internet.
                </li>
              </ol>
            </li>

            <li>
              <p>Interrupções e Atualizações</p>
              <ol type="i">
                <li>
                  A Plataforma poderá passar por interrupções, atualizações ou
                  indisponibilidades temporárias, programadas ou não, sem que
                  isso gere qualquer direito à indenização, compensação ou
                  reembolso ao Usuário.
                </li>
              </ol>
            </li>

            <li>
              <p>Links Externos</p>
              <ol type="i">
                <li>
                  A Plataforma poderá conter links para sites de terceiros. A
                  RESALE não se responsabiliza por conteúdo, políticas ou
                  práticas de privacidade de tais sites, que são regidos por
                  seus próprios termos.
                </li>
                <li>
                  A criação de links para páginas da Plataforma por terceiros
                  exige autorização prévia e expressa da RESALE, devendo
                  observar a legislação aplicável e a marca/identidade da
                  RESALE.
                </li>
              </ol>
            </li>

            <li>
              <p>Segurança, Antifraude e Antiphishing</p>
              <ol type="i">
                <li>
                  A RESALE nunca solicita senha por e-mail, telefone ou
                  aplicativos de mensagem. Em caso de comunicação suspeita em
                  nome da RESALE, não clique em links nem compartilhe dados.
                  Reporte pelo(s) canal(is) oficial(is) indicado(s) no site. O
                  Usuário é responsável por manter seu dispositivo seguro e
                  adotar boas práticas de proteção.
                </li>
              </ol>
            </li>
          </ol>
        </div>

        <div className={styles.space}>
          <h2 className={styles.spaceTop}>
            6) REGRAS DE COMPRA E VENDA DE IMÓVEIS
          </h2>

          <ol type="a">
            <li>
              <p>Informações sobre os Imóveis</p>
              <ol type="i">
                <li>
                  As informações sobre os imóveis disponíveis na Plataforma são
                  fornecidas pelos vendedores e/ou anunciantes, sendo
                  disponibilizadas em caráter meramente informativo. A RESALE
                  não se responsabiliza pela veracidade, exatidão ou atualização
                  de tais dados.
                </li>
              </ol>
            </li>

            <li>
              <p>Diligência do Comprador</p>
              <ol type="i">
                <li>
                  Cabe ao comprador realizar, por conta própria ou com apoio
                  profissional, as diligências jurídicas, fiscais e físicas
                  necessárias à avaliação do imóvel e de seus riscos, antes de
                  formalizar a compra.
                </li>
              </ol>
            </li>

            <li>
              <p>Condições Específicas por Imóvel</p>
              <ol type="i">
                <li>
                  As condições comerciais e jurídicas de cada imóvel (valor
                  mínimo, formas de pagamento, documentos exigidos, estado de
                  ocupação, existência de ônus, etc.) constarão na respectiva
                  Ficha do Imóvel, no edital ou no regulamento aplicável à
                  modalidade de venda.
                </li>
              </ol>
            </li>

            <li>
              <p>Não Vinculação Prévia</p>
              <ol type="i">
                <li>
                  O envio de proposta, manifestação de interesse ou participação
                  em processo de venda por meio da Plataforma não garante a
                  conclusão da transação nem gera expectativa de contratação. A
                  formalização da venda depende de aprovação expressa por parte
                  do vendedor e do cumprimento das etapas previstas para cada
                  modalidade.
                </li>
              </ol>
            </li>

            <li>
              <p>Formalização da Venda</p>
              <ol type="i">
                <li>
                  A formalização da venda, quando aprovada pelo Vendedor,
                  ocorrerá mediante assinatura eletrônica dos instrumentos
                  específicos definidos para cada modalidade de venda, como
                  Contrato de Prestação de Serviços, Promessa de Compra e Venda,
                  Ata de Arrematação ou Escritura Pública, conforme aplicável. A
                  RESALE poderá atuar com apoio de parceiros operacionais em
                  etapas específicas do processo.
                </li>
              </ol>
            </li>

            <li>
              <p>Atuação da RESALE</p>
              <ol type="i">
                <li>
                  A RESALE atua como prestadora de serviços tecnológicos e
                  operacionais, por meio de sua Plataforma digital, e, quando
                  contratado, da solução Pagimovel®. Salvo disposição expressa
                  em contrário, a RESALE não é parte na relação de compra e
                  venda entre comprador e vendedor. Em determinadas modalidades,
                  a RESALE poderá também atuar como canal de venda ou
                  responsável pela intermediação da transação, hipótese que será
                  informada de forma clara na Ficha Proposta e nos instrumentos
                  aplicáveis.
                </li>
              </ol>
            </li>
          </ol>
        </div>

        <div className={styles.space}>
          <h2 className={styles.spaceTop}>7) OBRIGAÇÕES DOS USUÁRIOS</h2>

          <p>
            Para manter um ambiente seguro e eficiente, esperamos que você use a
            Plataforma de forma ética, com dados verdadeiros, respeitando prazos
            e documentos, e sem práticas que prejudiquem outros usuários ou a
            RESALE.
          </p>

          <ol type="a">
            <li>
              <p>Obrigações Gerais</p>
              <ol type="i">
                <li>Todos os Usuários comprometem-se a:</li>
                <div>
                  <p>
                    (1) utilizar a Plataforma de forma ética, lícita e em
                    conformidade com este Termo e regulamentos aplicáveis;
                  </p>
                  <p>
                    (2) fornecer informações completas, verídicas e atualizadas
                    sempre que solicitado;
                  </p>
                  <p>
                    (3) manter confidenciais seus dados de acesso (login e
                    senha), responsabilizando-se integralmente por seu uso,
                    inclusive por terceiros;
                  </p>
                  <p>
                    (4) respeitar a legislação aplicável, em especial normas de
                    proteção de dados, combate à fraude, concorrência leal e
                    integridade nas transações;
                  </p>
                  <p>
                    (5) não praticar atos que possam prejudicar a RESALE, outros
                    Usuários ou o regular funcionamento da Plataforma.
                  </p>
                </div>
              </ol>
            </li>

            <li>
              <p>Obrigações dos Vendedores/Anunciantes</p>
              <ol type="i">
                <li>
                  Além das obrigações gerais, os vendedores e anunciantes
                  deverão:
                </li>
                <div>
                  <p>
                    (1) garantir a legitimidade e veracidade das informações e
                    documentos fornecidos sobre os imóveis;
                  </p>
                  <p>
                    (2) disponibilizar, quando solicitado, matrícula atualizada,
                    certidões e demais documentos necessários à conclusão da
                    venda;
                  </p>
                  <p>
                    (3) comunicar à RESALE eventuais alterações ou fatos
                    supervenientes que possam impactar a venda (ônus, ações
                    judiciais, ocupação, estado de conservação, etc.);
                  </p>
                  <p>
                    (4) observar os prazos, procedimentos e exigências
                    constantes deste Termo, dos regulamentos e da Ficha do
                    Imóvel;
                  </p>
                  <p>
                    (5) cumprir com a assinatura dos instrumentos contratuais
                    necessários à conclusão da operação, nos prazos informados.
                  </p>
                </div>
              </ol>
            </li>

            <li>
              <p>Obrigações dos Compradores/Proponentes</p>
              <ol type="i">
                <li>
                  Além das obrigações gerais, os compradores/proponentes
                  deverão:
                </li>
                <div>
                  <p>
                    (1) realizar as diligências necessárias sobre os imóveis
                    antes da formalização da compra;
                  </p>
                  <p>
                    (2) apresentar todos os documentos exigidos para validação
                    cadastral, compliance e crédito;
                  </p>
                  <p>
                    (3) observar os prazos e condições estabelecidos na Ficha
                    Proposta, Regulamento ou Edital aplicável;
                  </p>
                  <p>
                    (4) efetuar os pagamentos devidos à RESALE, à Pagimovel®
                    (quando aplicável), ao canal de venda e ao vendedor,
                    conforme os instrumentos contratuais da operação;
                  </p>
                  <p>
                    (5) cumprir integralmente os termos do regulamento
                    específico da modalidade de venda em que participar.
                  </p>
                </div>
              </ol>
            </li>

            <li>
              <p>Penalidades pelo Descumprimento</p>
              <ol type="i">
                <li>
                  O descumprimento das obrigações acima poderá resultar em:
                </li>
                <div>
                  <p>(1) suspensão ou exclusão do Usuário da Plataforma;</p>
                  <p>
                    (2) retenção de valores pagos a título de caução ou taxas de
                    serviço, quando aplicável;
                  </p>
                  <p>
                    (3) responsabilização civil e criminal do Usuário infrator;
                  </p>
                  <p>
                    (4) aplicação das penalidades previstas nos contratos e
                    regulamentos específicos.
                  </p>
                </div>
              </ol>
            </li>
          </ol>
        </div>

        <div className={styles.space}>
          <h2 className={styles.spaceTop}>8) OBRIGAÇÕES DA RESALE</h2>

          <ol type="a">
            <li>
              <p>Prestação dos Serviços</p>
              <ol type="i">
                <li>
                  RESALE compromete-se a disponibilizar a Plataforma de forma
                  contínua, segura e eficiente, adotando práticas de tecnologia
                  compatíveis com os padrões de mercado.
                </li>
              </ol>
            </li>

            <li>
              <p>Transparência das Informações</p>
              <ol type="i">
                <li>
                  A RESALE deverá assegurar que as condições aplicáveis a cada
                  produto, tipo de venda e imóvel estejam descritas de forma
                  clara na Plataforma, na Ficha do Imóvel, no Regulamento ou no
                  Edital correspondente.
                </li>
              </ol>
            </li>

            <li>
              <p>Suporte ao Usuário</p>
              <ol type="i">
                <li>
                  A RESALE prestará suporte operacional e tecnológico aos
                  Usuários para utilização da Plataforma, por meio de canais
                  oficiais de atendimento, disponibilizados em seu site ou em
                  comunicações específicas.
                </li>
                <li>
                  Tratamento de Dados Pessoais
                  <div>
                    <p>
                      (1) A RESALE realizará o tratamento dos dados pessoais dos
                      Usuários em conformidade com a Lei nº 13.709/2018 (LGPD),
                      observando os princípios da finalidade, adequação,
                      necessidade e segurança, conforme descrito em sua Política
                      de Privacidade.
                    </p>
                  </div>
                </li>
              </ol>
            </li>

            <li>
              <p>Confidencialidade</p>
              <ol type="i">
                <li>
                  A RESALE manterá confidencialidade sobre documentos e
                  informações recebidas dos Usuários, utilizando-os apenas para
                  a execução dos serviços e para cumprimento de obrigações
                  legais ou regulatórias.
                </li>
              </ol>
            </li>
          </ol>
        </div>

        <div className={styles.space}>
          <h2 className={styles.spaceTop}>9) LIMITAÇÃO DE RESPONSABILIDADE</h2>

          <ol type="a">
            <li>
              <p>Informações de Terceiros</p>
              <ol type="i">
                <li>
                  A RESALE não se responsabiliza pela veracidade, atualização ou
                  completude das informações fornecidas por vendedores,
                  compradores, canais de venda ou terceiros. A responsabilidade
                  por tais informações é exclusiva da parte que as
                  disponibilizar.
                </li>
              </ol>
            </li>

            <li>
              <p>Aprovação de Propostas</p>
              <ol type="i">
                <li>
                  A decisão de aceitar, recusar ou condicionar uma proposta é de
                  competência exclusiva do vendedor, não cabendo à RESALE
                  qualquer responsabilidade quanto a tal decisão.
                </li>
              </ol>
            </li>

            <li>
              <p>Indisponibilidade da Plataforma</p>
              <ol type="i">
                <li>
                  A RESALE não será responsável por indisponibilidades
                  temporárias da Plataforma decorrentes de manutenção,
                  atualizações, falhas técnicas, indisponibilidade de internet
                  ou fatos de terceiros alheios ao seu controle.
                </li>
              </ol>
            </li>

            <li>
              <p>Limites da Atuação da RESALE</p>
              <ol type="i">
                <li>
                  A RESALE atua como prestadora de serviços tecnológicos e
                  operacionais, podendo também atuar como canal de venda, quando
                  indicado na Ficha Proposta. Salvo disposição contratual
                  expressa, a RESALE não é parte na relação de compra e venda de
                  imóveis realizada entre comprador e vendedor.
                </li>
              </ol>
            </li>

            <li>
              <p>Danos Indiretos e Lucros Cessantes</p>
              <ol type="i">
                <li>
                  A RESALE não será responsável, em qualquer hipótese, por danos
                  indiretos, lucros cessantes, perda de oportunidade ou
                  quaisquer prejuízos imateriais alegados por Usuários em
                  decorrência do uso da Plataforma.
                </li>
              </ol>
            </li>

            <li>
              <p>Caso Fortuito e Força Maior</p>
              <ol type="i">
                <li>
                  A RESALE não será responsabilizada por falhas ou atrasos
                  resultantes de caso fortuito ou força maior, nos termos do
                  artigo 393 do Código Civil.
                </li>
              </ol>
            </li>
          </ol>
        </div>

        <div className={styles.space}>
          <h2 className={styles.spaceTop}>10) REMUNERAÇÃO E CUSTOS</h2>

          <ol type="a">
            <li>
              <p>Taxa da Plataforma</p>
              <ol type="i">
                <li>
                  Remunera os serviços tecnológicos e operacionais prestados
                  pela RESALE, incluindo divulgação de imóveis e suporte às
                  transações. O valor será informado de forma clara na oferta do
                  imóvel.
                </li>
              </ol>
            </li>

            <li>
              <p>Comissão de Intermediação</p>
              <ol type="i">
                <li>
                  É a remuneração devida ao canal de venda que atuar na
                  intermediação do negócio, devidamente inscrito no CRECI. O
                  valor será indicado na Ficha do Imóvel, Ficha Proposta ou
                  instrumento aplicável.
                </li>
              </ol>
            </li>

            <li>
              <p>Taxa de Serviços da Pagimovel®</p>
              <ol type="i">
                <li>
                  Refere-se aos serviços de regularização, escrituração e
                  registro do imóvel. É distinta da comissão e da taxa da
                  Plataforma, sendo contratada por instrumento específico.
                </li>
              </ol>
            </li>

            <li>
              <p>Responsabilidade pelo Pagamento</p>
              <ol type="i">
                <li>
                  Salvo disposição em contrário, as taxas são de
                  responsabilidade do comprador/proponente e não se confundem
                  com o preço do imóvel. Se o vendedor assumir parte dos
                  valores, isso constará na Ficha Proposta ou instrumento
                  contratual.
                </li>
              </ol>
            </li>

            <li>
              <p>Inadimplemento</p>
              <ol type="i">
                <li>
                  O não pagamento poderá resultar em: a) cancelamento da
                  proposta ou desclassificação do comprador; b) retenção de
                  caução, quando aplicável; c) suspensão do acesso do usuário à
                  Plataforma; d) cobrança administrativa ou judicial dos valores
                  devidos.
                </li>
              </ol>
            </li>
          </ol>
        </div>

        <div className={styles.space}>
          <h2 className={styles.spaceTop}>
            11) CANCELAMENTO, DESISTÊNCIA E REGRAS DE DEVOLUÇÃO
          </h2>

          <ol type="a">
            <li>
              <p>Regulação Específica</p>
              <ol type="i">
                <li>
                  As condições de cancelamento de operações, desistência de
                  comprador ou vendedor, devolução de valores e aplicação de
                  penalidades são disciplinadas nos contratos e instrumentos
                  específicos de cada modalidade de venda (Ficha Proposta,
                  Regulamento, Edital ou Ata de Arrematação).
                </li>
              </ol>
            </li>

            <li>
              <p>Papel da RESALE</p>
              <ol type="i">
                <li>
                  A RESALE poderá atuar como facilitadora nos procedimentos de
                  devolução ou repasse de valores, quando aplicável, observados
                  os limites de sua atuação. Em nenhuma hipótese a RESALE será
                  responsável por realizar devoluções com recursos próprios sem
                  o correspondente ressarcimento ou autorização do vendedor.
                </li>
              </ol>
            </li>

            <li>
              <p>Caução e Taxas de Serviço</p>
              <ol type="i">
                <li>
                  O envio de propostas poderá exigir o pagamento de caução ou
                  taxas de serviço, cujas regras de restituição ou retenção
                  estarão definidas no instrumento contratual da operação. A
                  falta de pagamento, a desistência ou o inadimplemento pelo
                  comprador poderão resultar em perda de valores pagos, conforme
                  previsto no contrato.
                </li>
              </ol>
            </li>

            <li>
              <p>Prevalência dos Contratos</p>
              <ol type="i">
                <li>
                  Em caso de conflito entre este Termo de Uso e os contratos ou
                  regulamentos específicos da modalidade, prevalecerá o disposto
                  nestes últimos.
                </li>
              </ol>
            </li>
          </ol>
        </div>

        <div className={styles.space}>
          <h2 className={styles.spaceTop}>12) PROPRIEDADE INTELECTUAL</h2>

          <ol type="a">
            <li>
              <p>Titularidade</p>
              <ol type="i">
                <li>
                  Todos os direitos de propriedade intelectual relacionados à
                  Plataforma, incluindo softwares, códigos, layout, bases de
                  dados, conteúdos, logotipos, marcas, nomes empresariais e
                  demais elementos, são de titularidade exclusiva da RESALE ou
                  de seus licenciadores.
                </li>
              </ol>
            </li>

            <li>
              <p>Licença de Uso Restrita</p>
              <ol type="i">
                <li>
                  O acesso e a utilização da Plataforma não conferem ao Usuário
                  qualquer direito de propriedade sobre tais ativos, sendo
                  concedida apenas licença de uso restrita, pessoal, não
                  exclusiva, intransferível e revogável, limitada às finalidades
                  previstas neste Termo.
                </li>
              </ol>
            </li>

            <li>
              <p>Vedações</p>
              <ol type="i">
                <li>
                  É vedado ao Usuário, sem autorização expressa da RESALE:
                  <div>
                    <p>
                      (1) copiar, reproduzir, modificar, traduzir, adaptar ou
                      criar obras derivadas a partir da Plataforma ou de seus
                      conteúdos;
                    </p>
                    <p>
                      (2) utilizar qualquer marca, logotipo, nome empresarial ou
                      sinal distintivo da RESALE, salvo quando expressamente
                      autorizado no contexto da transação;
                    </p>
                    <p>
                      (3) praticar engenharia reversa, descompilação, extração
                      de dados ou qualquer outra forma de uso indevido da
                      Plataforma.
                    </p>
                  </div>
                </li>
              </ol>
            </li>

            <li>
              <p>Conteúdos de Usuários</p>
              <ol type="i">
                <li>
                  As informações, documentos ou arquivos inseridos na Plataforma
                  pelos Usuários permanecem de sua titularidade, mas estes
                  concedem à RESALE licença de uso gratuita e não exclusiva,
                  limitada à execução dos serviços, cumprimento de obrigações
                  legais e desenvolvimento das funcionalidades da Plataforma.
                </li>
              </ol>
            </li>

            <li>
              <p>Proteção Legal</p>
              <ol type="i">
                <li>
                  A violação desta cláusula poderá ensejar suspensão do acesso
                  do Usuário, responsabilização civil e criminal, bem como a
                  adoção das medidas cabíveis pela RESALE, nos termos da
                  legislação aplicável, incluindo a Lei nº 9.279/1996 (Lei de
                  Propriedade Industrial) e a Lei nº 9.610/1998 (Lei de Direitos
                  Autorais).
                </li>
              </ol>
            </li>
          </ol>
        </div>

        <div className={styles.space}>
          <h2 className={styles.spaceTop}>13) PROTEÇÃO DE DADOS PESSOAIS</h2>

          <ol type="a">
            <li>
              <p>Tratamento de Dados</p>
              <ol type="i">
                <li>
                  A RESALE realiza o tratamento de dados pessoais dos Usuários
                  em conformidade com a Lei nº 13.709/2018 (Lei Geral de
                  Proteção de Dados – LGPD) e demais normas aplicáveis,
                  observando os princípios da finalidade, adequação, necessidade
                  e segurança.
                </li>
              </ol>
            </li>

            <li>
              <p>Finalidades</p>
              <ol type="i">
                <li>
                  Os dados pessoais coletados na Plataforma poderão ser
                  utilizados para:
                  <div>
                    <p>
                      (1) viabilizar a utilização das funcionalidades da
                      Plataforma;
                    </p>
                    <p>
                      (2) possibilitar a participação em modalidades de venda e
                      a formalização de contratos;
                    </p>
                    <p>
                      (3) cumprir obrigações legais, regulatórias ou de
                      autoridades competentes; prevenir fraudes e garantir a
                      segurança das transações;
                    </p>
                    <p>
                      (4) realizar comunicações operacionais, institucionais ou
                      comerciais, respeitadas as preferências do Usuário.
                    </p>
                  </div>
                </li>
              </ol>
            </li>

            <li>
              <p>Compartilhamento de Dados</p>
              <ol type="i">
                <li>
                  Os dados pessoais poderão ser compartilhados com:
                  <div>
                    <p>
                      (1) vendedores, compradores e canais de venda,
                      estritamente para execução das operações imobiliárias;
                    </p>
                    <p>
                      (2) parceiros e prestadores de serviços necessários ao
                      cumprimento das etapas da transação, como a Pagimovel®;
                    </p>
                    <p>
                      (3) autoridades públicas ou órgãos reguladores, quando
                      exigido por lei ou ordem judicial.
                    </p>
                  </div>
                </li>
              </ol>
            </li>

            <li>
              <p>Direitos dos Usuários</p>
              <ol type="i">
                <li>
                  O Usuário poderá, a qualquer tempo e mediante solicitação
                  formal, exercer seus direitos previstos na LGPD, incluindo
                  acesso, correção, exclusão ou portabilidade de seus dados,
                  conforme descrito na Política de Privacidade da RESALE.
                </li>
              </ol>
            </li>

            <li>
              <p>Política de Privacidade e Políticas Complementares</p>
              <ol type="i">
                <li>
                  A Política de Privacidade da RESALE, disponível em: (
                  <a
                    href="https://resale.com.br/termos/privacidade"
                    target="_blank"
                    rel="noreferrer"
                  >
                    https://resale.com.br/termos/privacidade
                  </a>
                  ), complementa esta cláusula e deve ser consultada para
                  detalhes adicionais sobre coleta, armazenamento,
                  compartilhamento e segurança das informações. A Política de
                  Privacidade integra, em conjunto com a Política de Exclusão de
                  Dados e a Política de Cookies, o conjunto de regras aplicáveis
                  ao tratamento de dados pessoais no âmbito da Plataforma.
                </li>
              </ol>
            </li>

            <li>
              <p>Exclusão de Dados</p>
              <ol type="i">
                <li>
                  O Usuário poderá solicitar a exclusão de seus dados pessoais
                  de acordo com as regras e procedimentos estabelecidos na
                  Política de Exclusão de Dados da RESALE, disponível em: (
                  <a
                    href="https://resale.com.br/termos/exclusao_de_dados"
                    target="_blank"
                    rel="noreferrer"
                  >
                    https://resale.com.br/termos/exclusao_de_dados
                  </a>
                  ). A exclusão observará os prazos e exceções previstos na
                  legislação aplicável, especialmente nos casos em que a
                  manutenção dos dados seja necessária para cumprimento de
                  obrigação legal, regulatória ou contratual.
                </li>
              </ol>
            </li>

            <li>
              <p>Cookies e Tecnologias de Rastreamento</p>
              <ol type="i">
                <li>
                  RESALE utiliza cookies e tecnologias semelhantes para melhorar
                  a experiência do Usuário na Plataforma, personalizar
                  conteúdos, analisar métricas e oferecer comunicações
                  relevantes. O uso dessas tecnologias é regido pela Política de
                  Cookies da RESALE, disponível em: (
                  <a
                    href="https://resale.com.br/termos/cookies"
                    target="_blank"
                    rel="noreferrer"
                  >
                    https://resale.com.br/termos/cookies
                  </a>
                  ). Ao continuar a navegar na Plataforma, o Usuário manifesta
                  ciência e concordância com a utilização de cookies, conforme
                  descrito na referida política.
                </li>
              </ol>
            </li>

            <li>
              <p>Encarregado (DPO)</p>
              <ol type="i">
                <li>
                  O canal de contato com o Encarregado (DPO) da RESALE para
                  dúvidas ou solicitações relacionadas ao tratamento de dados
                  pessoais encontra-se disponível na Política de Privacidade.
                </li>
              </ol>
            </li>
          </ol>
        </div>

        <div className={styles.space}>
          <h2 className={styles.spaceTop}>14) DISPOSIÇÕES GERAIS</h2>

          <ol type="a">
            <li>
              <p>Legislação Aplicável</p>
              <ol type="i">
                <li>
                  Este Termo será regido e interpretado de acordo com as leis da
                  República Federativa do Brasil.
                </li>
              </ol>
            </li>

            <li>
              <p>Foro</p>
              <ol type="i">
                <li>
                  Fica eleito o foro da Comarca de São Paulo/SP, com renúncia
                  expressa de qualquer outro, por mais privilegiado que seja,
                  para dirimir dúvidas ou controvérsias decorrentes deste Termo.
                </li>
              </ol>
            </li>

            <li>
              <p>Prevalência de Regulamentos Específicos</p>
              <ol type="i">
                <li>
                  Em caso de conflito entre este Termo de Uso e os regulamentos,
                  editais, contratos ou instrumentos específicos aplicáveis a
                  determinado produto, tipo de venda ou imóvel, prevalecerá o
                  disposto nestes últimos.
                </li>
              </ol>
            </li>

            <li>
              <p>Comunicações</p>
              <ol type="i">
                <li>
                  A RESALE poderá realizar comunicações por e-mail, mensagens
                  dentro da Plataforma e outros canais oficiais indicados no
                  site. O Usuário deve manter seus dados atualizados e verificar
                  regularmente sua caixa de entrada (inclusive “spam”/“lixo
                  eletrônico”).
                </li>
              </ol>
            </li>

            <li>
              <p>Alterações do Termo</p>
              <ol type="i">
                <li>
                  A RESALE poderá alterar este Termo a qualquer tempo, sendo a
                  versão atualizada publicada na Plataforma e comunicada aos
                  Usuários por meio de aviso destacado. A continuidade do uso da
                  Plataforma após a publicação da nova versão implicará
                  concordância integral com as alterações.
                </li>
              </ol>
            </li>

            <li>
              <p>Nulidade Parcial</p>
              <ol type="i">
                <li>
                  Caso qualquer disposição deste Termo venha a ser considerada
                  inválida ou inexequível, tal invalidade não afetará as demais
                  disposições, que permanecerão em pleno vigor e efeito.
                </li>
              </ol>
            </li>
          </ol>
        </div>

        <div className={styles.space}>
          <h2 className={styles.spaceTop}>15) VIGÊNCIA E ACEITE</h2>

          <ol type="a">
            <li>
              <p>Vigência</p>
              <ol type="i">
                <li>
                  O presente Termo entra em vigor na data de sua publicação na
                  Plataforma e permanecerá válido por prazo indeterminado,
                  enquanto não substituído por nova versão.
                </li>
              </ol>
            </li>

            <li>
              <p>Aceite Eletrônico</p>
              <ol type="i">
                <li>
                  Ao se cadastrar, acessar ou utilizar qualquer funcionalidade
                  da Plataforma, o Usuário manifesta sua ciência e concordância
                  integral com este Termo, por meio de aceite eletrônico, que
                  possui validade jurídica plena e substitui a assinatura
                  física, nos termos da legislação aplicável.
                </li>
              </ol>
            </li>

            <li>
              <p>Versão Atual</p>
              <ol type="i">
                <li>
                  A versão vigente deste Termo estará sempre disponível para
                  consulta na Plataforma, prevalecendo sobre quaisquer versões
                  anteriores.
                </li>
              </ol>
            </li>
          </ol>
        </div>
      </div>

      <p className={styles.version}>DOR030 - v3.0 - 20250912</p>
    </div>
  )
}
